import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { User } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number
  options?: Omit<
    UseQueryOptions<unknown, Error, User>,
    'queryKey' | 'queryFn'
  >;
}

export const useUserRequest = ({
  id,
  options,
}: RequestParams) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, User>(
    [Entities.Users, id],
    async () => {
      const { data } = await api.v1AdminUsersUserIdGet(id)
      return data
    },
    {
      ...options,
    },
  )
}
